<router-outlet></router-outlet>
<out-cookie-consent></out-cookie-consent>
<!-- <out-chatbot-icon *ngIf="showChatbotIcon"></out-chatbot-icon> -->
<out-idle [show]="showWarning" [countdown]="countdown" (continueSession)="resetIdle()"></out-idle>
